import test_1 from "../assets/images/test1.jpeg";
import test_2 from "../assets/images/test2.jpeg";

export const rentalcontactinfo = [
  {
    value: "Coming Soon 1",
    label: "Coming Soon 1",
  },
  {
    value: "Coming Soon 2",
    label: "Coming Soon 2",
  },
  {
    value: "Coming Soon 3",
    label: "Coming Soon 3",
  },
];

export const guestcsrdassignedto = [
  {
    value: "Unassigned",
    label: "Unassigned",
  },
  {
    value: "Allan Miraflor",
    label: "Allan Miraflor",
  },
  {
    value: "Chris Loney",
    label: "Chris Loney",
  },
  {
    value: "Derek Dorris",
    label: "Derek Dorris",
  },
];
export const contactinfo = [
  {
    value: "322",
    label: "322",
  },
  {
    value: "33",
    label: "33",
  },
  {
    value:  "23323",
    label:  "23323",
  },
 
  {
    value: "kelly s - (405) 888-9090",
    label: "kelly s - (405) 888-9090",
  },
  {
    value: "shanon sepory - (405) 924-9458",
    label: "shanon sepory - (405) 924-9458",
  },
  {
    value: "Star Vick - (405) 609-4507",
    label: "Star Vick - (405) 609-4507",
  },
  {
    value: "michel shall - (405) 439-6082",
    label: "michel shall - (405) 439-6082",
  },
  {
    value: "Tonya Scales - (405) 201-7193",
    label: "Tonya Scales - (405) 201-7193",
  },
];

export const Propertiesunitscampaigns = [

  "xyz",
  "Single Family",
  "Mulit Family",
  "Manufactured-Housing",
  "test4 - 912 n creek dr  edmond, OK 73034 - $0.00",
  "test 5 - 1800 canyon park circle  edmond, OK 73013 - $0.00",


  // "test1 - 912 n creek dr  edmond, OK 73034",
  // "test2 - 912 n creek dr  edmond, OK 73034 - $0.00",
  // "test3 - 1800 canyon park circle  edmond, OK 73013",
  // "test4 - 912 n creek dr  edmond, OK 73034 - $0.00",
  // "test 5 - 1800 canyon park circle  edmond, OK 73013 - $0.00",
];
export const Rentalstatus = [
  "Approved",
  "Converting",
  "Decision Pending",
  "New",
  "Cold",
];

export const rentalApplicationsData = [
  {
    title: "1817 Treat Drive",
    imageSource: test_1,
    address: "1817 Treat Drive Midwest City, OK 73110",
    marketRent: 875,
    vacantOn: "01/27/2023",
    userRentalAppData: [
      {
        id: 1,
        userName: "Robert",
        desiredMoveIn: "01/27/2023",
        status: "Denied",
        residentailHistory: "None Requested",
        RecievedDate: "01/12/2023 11:23 am",
        contact: {
          phoneNumbers: [
            {
              number: "(309) 231-4041  Text",
              type: "phone",
              description: "",
            },
          ],
          emails: [
            {
              email: "mcarey91@gmail.com",
            },
          ],
          type: "Financialy Responsible",
        },
        applicantSummary: {
          status: "Denied",
          reasonForDenial: `Thank you for your rental application. We wanted to let you know that unfortunately your 
application was not approved due to credit score.

To read more about our approval guidelines, please visit https://integrityoklahoma.com/apply/

Please let us know if you have any questions.`,
          unit: "1817 Treat Drive",
          listingStatus: "Posted",
          vacantOn: "01/27/2023",
          desiredMoveIn: "03/01/2021",
          assignedUser: "--",
          received: "02/08/2021",
          applicantReportedSource: "Zillow",
          residentialHistory: "over 4 years provided",
          totalMonthlyIncome: "54220.00",
          applyingWith: "Samantha Foreman ",
          dependents: "Yes",
          pets: "Yes",
          attachments: "No",
        },
        screeningReports: {
          cardTitle: "Robert L. Sullivan",
        },
      },
      {
        id: 2,
        userName: "Robert",
        desiredMoveIn: "01/27/2023",
        status: "Denied",
        residentailHistory: "None Requested",
        RecievedDate: "01/12/2023 11:23 am",
        contact: {
          phoneNumbers: [
            {
              number: "(309) 231-4041  Text",
              type: "phone",
              description: "",
            },
          ],
          emails: [
            {
              email: "mcarey91@gmail.com",
            },
          ],
          type: "Financialy Responsible",
        },
        applicantSummary: {
          status: "Denied",
          reasonForDenial: `Thank you for your rental application. We wanted to let you know that unfortunately your 
application was not approved due to credit score.

To read more about our approval guidelines, please visit https://integrityoklahoma.com/apply/

Please let us know if you have any questions.`,
          unit: "1817 Treat Drive",
          listingStatus: "Posted",
          vacantOn: "01/27/2023",
          desiredMoveIn: "03/01/2021",
          assignedUser: "--",
          received: "02/08/2021",
          applicantReportedSource: "Zillow",
          residentialHistory: "over 4 years provided",
          totalMonthlyIncome: "54220.00",
          applyingWith: "Samantha Foreman ",
          dependents: "Yes",
          pets: "Yes",
          attachments: "No",
        },
        screeningReports: {
          cardTitle: "Robert L. Sullivan",
        },
      },
      {
        id: 3,
        userName: "Robert",
        desiredMoveIn: "01/27/2023",
        status: "Denied",
        residentailHistory: "None Requested",
        RecievedDate: "01/12/2023 11:23 am",
        contact: {
          phoneNumbers: [
            {
              number: "(309) 231-4041  Text",
              type: "phone",
              description: "",
            },
          ],
          emails: [
            {
              email: "mcarey91@gmail.com",
            },
          ],
          type: "Financialy Responsible",
        },
        applicantSummary: {
          status: "Denied",
          reasonForDenial: `Thank you for your rental application. We wanted to let you know that unfortunately your 
application was not approved due to credit score.

To read more about our approval guidelines, please visit https://integrityoklahoma.com/apply/

Please let us know if you have any questions.`,
          unit: "1817 Treat Drive",
          listingStatus: "Posted",
          vacantOn: "01/27/2023",
          desiredMoveIn: "03/01/2021",
          assignedUser: "--",
          received: "02/08/2021",
          applicantReportedSource: "Zillow",
          residentialHistory: "over 4 years provided",
          totalMonthlyIncome: "54220.00",
          applyingWith: "Samantha Foreman ",
          dependents: "Yes",
          pets: "Yes",
          attachments: "No",
        },
        screeningReports: {
          cardTitle: "Robert L. Sullivan",
        },
      },
    ],
  },
  {
    title: "9626 SE 4th",
    imageSource: test_2,
    address: "9626 SE 4th Midwest City, OK 73130",
    marketRent: 775,
    vacantOn: "Not Vacant",
    userRentalAppData: [
      {
        id: 1,
        userName: "Robert",
        desiredMoveIn: "01/27/2023",
        status: "Denied",
        residentailHistory: "None Requested",
        RecievedDate: "01/12/2023 11:23 am",
        contact: {
          phoneNumbers: [
            {
              number: "(309) 231-4041  Text",
              type: "phone",
              description: "",
            },
          ],
          emails: [
            {
              email: "mcarey91@gmail.com",
            },
          ],
          type: "Financialy Responsible",
        },
        applicantSummary: {
          status: "Denied",
          reasonForDenial: `Thank you for your rental application. We wanted to let you know that unfortunately your 
application was not approved due to credit score.

To read more about our approval guidelines, please visit https://integrityoklahoma.com/apply/

Please let us know if you have any questions.`,
          unit: "1817 Treat Drive",
          listingStatus: "Posted",
          vacantOn: "01/27/2023",
          desiredMoveIn: "03/01/2021",
          assignedUser: "--",
          received: "02/08/2021",
          applicantReportedSource: "Zillow",
          residentialHistory: "over 4 years provided",
          totalMonthlyIncome: "54220.00",
          applyingWith: "Samantha Foreman ",
          dependents: "Yes",
          pets: "Yes",
          attachments: "No",
        },
        screeningReports: {
          cardTitle: "Robert L. Sullivan",
        },
      },
      {
        id: 2,
        userName: "Robert",
        desiredMoveIn: "01/27/2023",
        status: "Denied",
        residentailHistory: "None Requested",
        RecievedDate: "01/12/2023 11:23 am",
        contact: {
          phoneNumbers: [
            {
              number: "(309) 231-4041  Text",
              type: "phone",
              description: "",
            },
          ],
          emails: [
            {
              email: "mcarey91@gmail.com",
            },
          ],
          type: "Financialy Responsible",
        },
        applicantSummary: {
          status: "Denied",
          reasonForDenial: `Thank you for your rental application. We wanted to let you know that unfortunately your 
application was not approved due to credit score.

To read more about our approval guidelines, please visit https://integrityoklahoma.com/apply/

Please let us know if you have any questions.`,
          unit: "1817 Treat Drive",
          listingStatus: "Posted",
          vacantOn: "01/27/2023",
          desiredMoveIn: "03/01/2021",
          assignedUser: "--",
          received: "02/08/2021",
          applicantReportedSource: "Zillow",
          residentialHistory: "over 4 years provided",
          totalMonthlyIncome: "54220.00",
          applyingWith: "Samantha Foreman ",
          dependents: "Yes",
          pets: "Yes",
          attachments: "No",
        },
        screeningReports: {
          cardTitle: "Robert L. Sullivan",
        },
      },
      {
        id: 3,
        userName: "Robert",
        desiredMoveIn: "01/27/2023",
        status: "Denied",
        residentailHistory: "None Requested",
        RecievedDate: "01/12/2023 11:23 am",
        contact: {
          phoneNumbers: [
            {
              number: "(309) 231-4041  Text",
              type: "phone",
              description: "",
            },
          ],
          emails: [
            {
              email: "mcarey91@gmail.com",
            },
          ],
          type: "Financialy Responsible",
        },
        applicantSummary: {
          status: "Denied",
          reasonForDenial: `Thank you for your rental application. We wanted to let you know that unfortunately your 
application was not approved due to credit score.

To read more about our approval guidelines, please visit https://integrityoklahoma.com/apply/

Please let us know if you have any questions.`,
          unit: "1817 Treat Drive",
          listingStatus: "Posted",
          vacantOn: "01/27/2023",
          desiredMoveIn: "03/01/2021",
          assignedUser: "--",
          received: "02/08/2021",
          applicantReportedSource: "Zillow",
          residentialHistory: "over 4 years provided",
          totalMonthlyIncome: "54220.00",
          applyingWith: "Samantha Foreman ",
          dependents: "Yes",
          pets: "Yes",
          attachments: "No",
        },
        screeningReports: {
          cardTitle: "Robert L. Sullivan",
        },
      },
      {
        id: 4,
        userName: "Robert",
        desiredMoveIn: "01/27/2023",
        status: "Denied",
        residentailHistory: "None Requested",
        RecievedDate: "01/12/2023 11:23 am",
        contact: {
          phoneNumbers: [
            {
              number: "(309) 231-4041  Text",
              type: "phone",
              description: "",
            },
          ],
          emails: [
            {
              email: "mcarey91@gmail.com",
            },
          ],
          type: "Financialy Responsible",
        },
        applicantSummary: {
          status: "Denied",
          reasonForDenial: `Thank you for your rental application. We wanted to let you know that unfortunately your 
application was not approved due to credit score.

To read more about our approval guidelines, please visit https://integrityoklahoma.com/apply/

Please let us know if you have any questions.`,
          unit: "1817 Treat Drive",
          listingStatus: "Posted",
          vacantOn: "01/27/2023",
          desiredMoveIn: "03/01/2021",
          assignedUser: "--",
          received: "02/08/2021",
          applicantReportedSource: "Zillow",
          residentialHistory: "over 4 years provided",
          totalMonthlyIncome: "54220.00",
          applyingWith: "Samantha Foreman ",
          dependents: "Yes",
          pets: "Yes",
          attachments: "No",
        },
        screeningReports: {
          cardTitle: "Robert L. Sullivan",
        },
      },
    ],
  },
];

// export const Propertiesunitscampaigns = [
//   { value: "test1", label: "912 n creek dr  edmond, OK 73034" },
//   { value: "test2", label: "912 n creek dr  edmond, OK 73034 - $0.00" },
//   { value: "test3", label: "1800 canyon park circle  edmond, OK 73013" },
//   { value: "test4", label: "912 n creek dr  edmond, OK 73034 - $0.00" },
//   { value: "test5", label: "1800 canyon park circle  edmond, OK 73013 - $0.00" },
//   { value: "xyz", label: "xyz" }
// ];

// export const Rentalstatus = [
//   { value: "Approved", label: "Approved" },
//   { value: "Converting", label: "Converting" },
//   { value: "Decision Pending", label: "Decision Pending" },
//   { value: "New", label: "New" },
//   { value: "Cold", label: "Cold" }

// ];
